import noSalesRecordImage from "../../assetsStatic/NoSalesRecord.png";
import "../../styles/salesRecord/salesRecord.css";
import Template from "../Template";
import { BsFilter, BsSearch } from "react-icons/bs";
import SelectStoreTab from "../../components/tabs/SelectStoreTab";
import EachSalesRecord from "./EachSalesRecord";
import BarChart from "../../components/charts/BarChat";
import DoughnutChart from "../../components/charts/DoughnutChart";
import { useState, useLayoutEffect, useEffect } from "react";
import { getSalesRecordUrl, getCustomSalesRecordUrl } from "../../api/endpoints";
import { setUser } from "../../slice/webStoreUserSlice";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../components/uxCollections/Loaders";
import CustomeDateSearch from "../../components/filter/CustomeDateSearch";
import SalesRecordSkeleton from "../../components/uxCollections/skeletonLoader/salesRecord/SalesRecordSkeleton";
import { ArrowBigDown, ArrowDownToLine, MoveDown } from "lucide-react";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

const SalesRecord = () => {
  const [filterRecordBasedOnStore, setFilterRecordBasedOnStore] = useState({ storeName: "All stores", storeId: "1" });
  const [resetStoreFilter, setResetStoreFilter] = useState(false);
  const [fetchCount, setFetchCount] = useState(0);
  const [salesRecordDay, setSalesRecordDay] = useState(""); /* today or yesterday */
  const [salesRecordList, setSalesRecordList] = useState(null);
  const [salesRecordListCopy, setSalesRecordListCopy] = useState(null);
  const [salesRecordListBeforePurchaseModeFilter, setSalesRecordListBeforePurchaseModeFilter] = useState(null);
  const [salesTotal, setSalesTotal] = useState(0);
  const [topThreeProducts, setTopThreeProducts] = useState(null); /* array of two array */
  const [salesChart, setSalesChart] = useState(null); /* array of three array */
  const [selectedTab, setSelectedTab] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [newUser, setNewUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true); //
  const [openCustomDateSearch, setOpenCustomDateSearch] = useState(false); /* open or close custom date search */
  const [customDates, setCustomDates] = useState({ fromDate: "", toDate: "" });
  const [whichPageToRender, setWhichPageToRender] = useState("salesRecord"); /* salesRecord || charts  on for mobile screens*/
  const userCurrency = useSelector((state) => state.webStoreUser.user.userCountryCurrencySymbol);
  console.log(userCurrency);

  useLayoutEffect(() => {
    setSalesRecordDay("Today");
    fetchSalesRecord();
    /*set event listerner restore whichPageToRender to salesRecord if width is more than 900px */

    window.addEventListener("resize", () => {
      if (window.innerWidth > 900) {
        setWhichPageToRender("salesRecord");
      }
    });
  }, []);
  useLayoutEffect(() => {
    salesRecordList && computeTotal(salesRecordList);
  }, [salesRecordList]);
  useLayoutEffect(() => {
    console.log(customDates);
  }, [customDates]);

  useLayoutEffect(() => {
    console.log(whichPageToRender);

    if (salesRecordDay === "Today" || salesRecordDay === "Yesterday") {
      whichPageToRender === "charts" && fetchSalesRecord();
    } else {
      /* customed date */
      console.log(customDates);
      whichPageToRender === "charts" && fetchCustomSalesRecord(customDates.fromDate, customDates.toDate);
    }
  }, [whichPageToRender]);

  /* refetch Sales according to sellected day or interval */
  useLayoutEffect(() => {
    if (salesRecordDay === "Today" || salesRecordDay === "Yesterday") {
      fetchSalesRecord();
    } else {
      /* customed date */

      fetchCustomSalesRecord(customDates.fromDate, customDates.toDate);
    }
  }, [salesRecordDay]);

  /* filter according to store */
  useLayoutEffect(() => {
    if (salesRecordList) {
      if (filterRecordBasedOnStore.storeName === "All stores") {
        setSalesRecordList((prev) => {
          return salesRecordListCopy;
        });
        setSelectedTab("all");
        setSalesRecordListBeforePurchaseModeFilter(salesRecordListCopy);
      } else {
        setSalesRecordList((prev) => {
          let newList = salesRecordListCopy.filter((record) => record.store.id === filterRecordBasedOnStore.storeId);
          setSalesRecordListBeforePurchaseModeFilter(newList);

          return newList;
        });
        setSelectedTab("all");
      }
    }
  }, [filterRecordBasedOnStore]);

  /* filter according to salesMode online || inStore */
  useLayoutEffect(() => {
    console.log(salesRecordListBeforePurchaseModeFilter);
    if (selectedTab === "online") {
      setSalesRecordList((prev) => {
        return salesRecordListBeforePurchaseModeFilter.filter((record) => record.purchaseMode === "online");
      });
      console.log(salesRecordList);
    } else if (selectedTab === "inShop") {
      setSalesRecordList((prev) => {
        return salesRecordListBeforePurchaseModeFilter.filter((record) => record.purchaseMode === "inStore");
      });
      console.log(salesRecordList);
    } else {
      setSalesRecordList(salesRecordListBeforePurchaseModeFilter);
    }
  }, [selectedTab]);

  /* compute totrak */

  const dispatch = useDispatch();

  /* fetch sales record */
  const fetchSalesRecord = async () => {
    setIsLoading(true);
    try {
      let response = await fetch(getSalesRecordUrl + salesRecordDay, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });

      if (response.ok) {
        let { user, salesRecords } = await response.json();
        console.log(salesRecords);
        dispatch(setUser(user));
        user.productsSoldInAllStores.length === 0 && setNewUser(true);
        setSalesRecordList(salesRecords);
        setSalesRecordListCopy(salesRecords);
        setSalesRecordListBeforePurchaseModeFilter(salesRecords);
        //computeTotal(salesRecords);
        findTopThreeProducts(user.productsSoldInAllStores);
        createSalesChart(user.salesChart);
        setSelectedTab("all");
        setFilterRecordBasedOnStore({ storeName: "All stores", storeId: "1" });

        setResetStoreFilter((prev) => !prev);
        setIsLoading(false);
        setFetchCount((prev) => prev + 1);
        console.log(fetchCount);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCustomSalesRecord = async (fromDate, toDate) => {
    setIsLoading(true);

    try {
      let response = await fetch(getCustomSalesRecordUrl + `${fromDate}/${toDate}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });
      if (response.ok) {
        let { user, salesRecords } = await response.json();
        dispatch(setUser(user));
        user.productsSoldInAllStores.length === 0 && setNewUser(true);
        setSalesRecordList(salesRecords);
        setSalesRecordListCopy(salesRecords);
        setSalesRecordListBeforePurchaseModeFilter(salesRecords);
        //computeTotal(salesRecords);
        findTopThreeProducts(user.productsSoldInAllStores);
        createSalesChart(user.salesChart);
        setSelectedTab("all");
        setFilterRecordBasedOnStore({ storeName: "All stores", storeId: "1" });
        setResetStoreFilter((prev) => !prev);
        setIsLoading(false);
        setFetchCount((prev) => prev + 1);
        console.log(fetchCount);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showIntervalTab = () => {
    let tab = document.querySelector(".chooseInterval");
    tab.classList.toggle("update74653");
    tab.classList.toggle("showInterval");
  };

  const findTopThreeProducts = (productArray) => {
    console.log(productArray);
    let topThreeProducts = productArray
      .slice()
      .sort((a, b) => b.quantitySold - a.quantitySold)
      .slice(0, 3);

    /* create an array of two array. first array is productName second is value */

    let topProductarray = topThreeProducts.reduce(
      (acc, cur) => {
        console.log(acc, cur);
        acc[0].push(cur.productName);
        acc[1].push(cur.quantitySold);
        return acc;
      },
      [[], []]
    );
    setTopThreeProducts(topProductarray);
  };

  const createSalesChart = (salesChartArray) => {
    /* find the year */
    console.log(salesChartArray);

    try {
      let year = new Date().getFullYear();
      let salesChart = salesChartArray.find((chart) => chart.year === year); /* an object */

      let salesChartArrayForBarChart = salesChart.stores.reduce(
        (acc, cur) => {
          cur.productsSoldPerMonth.forEach((store, index) => {
            if (acc[1].length > 11) {
              acc[1][index] += store.offlineSales;
              acc[0][index] += store.onlineSales;
            } else {
              console.log(cur.productsSoldPerMonth[index].offlineSales, cur.productsSoldPerMonth[index].onlineSales);
              acc[0].push(cur.productsSoldPerMonth[index].onlineSales);
              acc[1].push(cur.productsSoldPerMonth[index].offlineSales);
              acc[2].push(store.month);
            }
          });

          return acc;
        },
        [[], [], []]
      );

      setSalesChart(salesChartArrayForBarChart);
    } catch (error) {
      console.log(error);
    }
  };

  const computeTotal = (array) => {
    if (array.length === 0) {
      setSalesTotal(0);
      return;
    } else {
      let total = 0;
      array.forEach((item) => {
        total += item.totalPrice;
      });

      setSalesTotal(total);
    }
  };
  return (
    <>
      <Template>
        <h3 className='sRTitle22'>Sales Record</h3>
        <div className='customerFilter'>
          <SelectStoreTab updateSelectedStore={setFilterRecordBasedOnStore} resetFilter={resetStoreFilter} disableStoreFilter={false} />
          <div className='searchEmployeediv'>
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className='SearchTransact1 searchWarehouse'
              placeholder='Enter product name'
            />
            <span>
              <BsSearch />
            </span>
          </div>
          {/*   <button
            onClick={() => {
              uiAlert("Your bankable report will be available after 8months since you created your business . Please contact support for more information.");
              return;
            }}
            className='downloadSalesRecord'
          >
            <ArrowDownToLine size={18} />
          </button> */}
        </div>

        <SwitchTab whichPageToRender={whichPageToRender} setWhichTabtorender={setWhichPageToRender} />
        {isLoading ? (
          <div className=''>
            {/* <Spinner /> */}
            <SalesRecordSkeleton />
          </div>
        ) : (
          <div className='uppea3664'>
            {newUser ? (
              <div className='SalesRecordWrapper noSalesRecordDiv'>
                {" "}
                <img src={noSalesRecordImage} />
                <h3> Your store analysis would be shown here </h3>
                <p>Start selling to see your store analysis</p>
                <p></p>
              </div>
            ) : whichPageToRender === "salesRecord" ? (
              <div className='SalesRecordWrapper'>
                <div>
                  <div className='TabFilterSR46 '>
                    <div className='SalesRTab8334'>
                      <p onClick={(e) => setSelectedTab("all")} className={selectedTab === "all" ? "selectedTabSR2843" : ""}>
                        All
                      </p>
                      <p onClick={(e) => setSelectedTab("inShop")} className={selectedTab === "inShop" ? "selectedTabSR2843" : ""}>
                        In Shop
                      </p>
                      <p onClick={(e) => setSelectedTab("online")} className={selectedTab === "online" ? "selectedTabSR2843" : ""}>
                        Online
                      </p>
                    </div>

                    <div
                      style={{ padding: "4px 6px", gap: "6px", alignItems: "center", color: "#0E49B5", fontWeight: "600", cursor: "pointer" }}
                      className='TimelineTransactions'
                    >
                      <BsFilter onClick={showIntervalTab} />
                      <span style={{ fontSize: "0.85rem" }} onClick={showIntervalTab}>
                        {salesRecordDay}
                      </span>
                      <div style={{ bottom: "-180px", left: "-180px", width: "175px", minHeight: "160px" }} className='chooseInterval update74653'>
                        <p
                          onClick={() => {
                            setSalesRecordDay("Today");
                            showIntervalTab();
                          }}
                        >
                          {" "}
                          Today
                        </p>
                        <p
                          onClick={() => {
                            setSalesRecordDay("Yesterday");
                            showIntervalTab();
                          }}
                        >
                          Yesterday
                        </p>
                        <p
                          onClick={() => {
                            setOpenCustomDateSearch(true);
                            showIntervalTab();
                          }}
                        >
                          choose interval
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='EachRecordDiv374'>
                    {salesRecordList.length > 0 &&
                      salesRecordList
                        .filter((record) => record.name.toLowerCase().includes(searchValue.toLowerCase()))
                        .map((record) => <EachSalesRecord key={record._id} record={record} userCurrency={userCurrency} />)}
                  </div>
                </div>

                <div>
                  <div className='BarChatDIv23'>
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center" }}>
                      {salesChart ? (
                        <BarChart value={salesChart} userCurrency={userCurrency} />
                      ) : (
                        /*  */

                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "0.9rem", fontWeight: "600" }}>
                          {" "}
                          No data yet
                        </div>
                      )}
                    </div>
                  </div>
                  {!salesChart && <p style={{ textAlign: "center", fontSize: "0.9rem", fontWeight: "700" }}>Too three selling products</p>}
                  <div style={{ marginTop: "4px", height: "250px" }} className='BarChatDIv23'>
                    <div> {topThreeProducts && <DoughnutChart value={topThreeProducts} confiq={{ title: "Top selling products" }} />}</div>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ height: "85%" }} className='showChatMonek726'>
                {" "}
                <div>
                  <div className='BarChatDIv23'>
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center" }}>
                      {salesChart ? (
                        <BarChart value={salesChart} />
                      ) : (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "0.9rem", fontWeight: "600" }}>
                          {" "}
                          No data yet
                        </div>
                      )}
                    </div>
                  </div>
                  {!salesChart && <p style={{ textAlign: "center", fontSize: "0.9rem", fontWeight: "700" }}>Top three selling products</p>}
                  <div style={{ marginTop: "4px", height: "250px" }} className='BarChatDIv23'>
                    <div> {topThreeProducts && <DoughnutChart value={topThreeProducts} confiq={{ title: "Top selling products" }} />}</div>
                  </div>
                </div>
              </div>
            )}

            <div className='SalesRecDowlT56'>
              <div style={{ marginTop: "0" }} className='payoutTotalDIv23'>
                <p>Total</p>
                <p>
                  {userCurrency} {salesTotal?.toLocaleString()}
                </p>
              </div>
              {/*     {newUser ? (
                <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='DwloaSr34-btn'>
                  Download record
                </button>
              ) : (
                <button
                  onClick={() => {
                    uiAlert(
                      "Your bankable report will be available after 8months since you created your business . Please contact support for more information."
                    );
                    return;
                  }}
                  className='DwloaSr34-btn'
                >
                  Download record
                </button>
              )} */}
            </div>
          </div>
        )}
        {openCustomDateSearch && (
          <CustomeDateSearch
            closeModal={setOpenCustomDateSearch}
            setFetchCustomTrans={setCustomDates}
            setSalesTimeLine={setSalesRecordDay}
            disableDefault={true}
          />
        )}
      </Template>
    </>
  );
};

export default SalesRecord;

const SwitchTab = ({ whichPageToRender, setWhichTabtorender }) => {
  useLayoutEffect(() => {
    let movingTrain = document.querySelector(".movingTrain74trg");
    let activeTab = document.querySelector(".activeTab63654");
    let salesTab = document.getElementById("77343464");
    let chartsTab = document.getElementById("jf95858439");

    if (whichPageToRender === "salesRecord") {
      movingTrain.style.transform = "translateX(0%)";
      salesTab.classList.add("activeTab63654");
      chartsTab.classList.remove("activeTab63654");
    } else {
      movingTrain.style.transform = "translateX(102%)";
      chartsTab.classList.add("activeTab63654");
      salesTab.classList.remove("activeTab63654");
    }
  }, [whichPageToRender]);

  const handleSwitchTab = (e) => {};

  return (
    <>
      <div className='sTabWrapper33'>
        <div className='swtTabTrack22'>
          <div className='movingTrain74trg'></div>
          <div onClick={() => setWhichTabtorender("salesRecord")} id='77343464' className='activeTab63654'>
            Sales record
          </div>
          <div onClick={() => setWhichTabtorender("charts")} id='jf95858439'>
            Charts
          </div>
        </div>
      </div>
    </>
  );
};
